import NotFound from 'components/NotFound';
import React from 'react';
import { connect } from 'react-redux';
import { Redirect, Route, Switch } from 'react-router-dom';
import { ConnectedRouter } from 'react-router-redux';
import { Elements, StripeProvider } from 'react-stripe-elements';
import { FinancialRootPath } from 'utils/constants/routes';
import ConnectAccountPanel from './ConnectAccountPanel';

class FinancialContainer extends React.Component {
  render() {
    return (
      <StripeProvider apiKey={process.env.REACT_APP_STRIPE_KEY}>
        <Elements>
          <ConnectedRouter history={this.props.history}>
            <Switch>
              <Route
                path={`${FinancialRootPath}/connect`}
                component={ConnectAccountPanel}
              />
              <Redirect to={`${FinancialRootPath}/connect`} />
              {/* <Route
                path={`${FinancialRootPath}/subscription`}
                component={SubscriptionPanel}
              />
              <Route
                exact
                path={`${FinancialRootPath}/payouts/`}
                component={PayoutsPanel}
              />
              <Route
                exact
                path={`${FinancialRootPath}/payouts/:id`}
                component={PayoutTransactionsPanel}
              /> */}
              <Route component={NotFound} />
            </Switch>
          </ConnectedRouter>
        </Elements>
      </StripeProvider>
    );
  }
}

const mapStateToProps = state => ({});
const mapDispatchToProps = dispatch => ({});

export default connect(mapStateToProps, mapDispatchToProps)(FinancialContainer);



// WEBPACK FOOTER //
// ./src/components/Dashboard/Panels/Financial/index.jsx